'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
};

Object.defineProperty(exports, '__esModule', {
  value: !0
});
exports.default = createThemedComponent;

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _withTheme = require('./withTheme'),
    _withTheme2 = _interopRequireDefault(_withTheme),
    _createComponentTheme = require('./createComponentTheme'),
    _createComponentTheme2 = _interopRequireDefault(_createComponentTheme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function getComponentDisplayName(Component) {
  return 'string' == typeof Component ? Component : Component.displayName || Component.name || 'Component';
}

function createThemedComponent(ComponentToTheme, styleOverrides) {
  var ThemedComponent = function ThemedComponent(props, context) {
    var theme = props.theme,
        otherProps = _objectWithoutProperties(props, ['theme']),
        componentStyles = 'function' == typeof styleOverrides ? styleOverrides(props, context) : styleOverrides,
        componentTheme = (0, _createComponentTheme2.default)(theme, componentStyles);

    return _react2.default.createElement(ComponentToTheme, _extends({}, otherProps, {
      theme: componentTheme
    }));
  };

  return ThemedComponent.propTypes = ComponentToTheme.propTypes, ThemedComponent.displayName = 'Themed(' + getComponentDisplayName(ComponentToTheme) + ')', (0, _withTheme2.default)(ThemedComponent);
}